import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import AppGate from "./components/AppGate";
import AppMain from "./AppMain";
import LoginPage from "./pages/LoginPage";
import TrackingPage from "./pages/TrackingPage";

function AppRoutes() {
  const { idToken } = useAuth();
  return (
    <Routes>
      <Route path="/" element={<Navigate to={idToken ? "/app" : "/login"} replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppGate />
          </ProtectedRoute>
        }
      >
        <Route index element={<AppMain />} />
        <Route path="tracking" element={<TrackingPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
